import type { HexLibraryChapter } from '@/components/HexLibrary';

interface ChapterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (e: React.FormEvent) => void;
    editingChapter: HexLibraryChapter | null;
    chapterTitle: string;
    setChapterTitle: (title: string) => void;
    isSaving: boolean;
}

export function ChapterModal({
    isOpen,
    onClose,
    onSubmit,
    editingChapter,
    chapterTitle,
    setChapterTitle,
    isSaving,
}: ChapterModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-slate-800 rounded-lg p-6 w-full max-w-md border border-slate-700">
                <h3 className="text-lg font-semibold text-white mb-4">
                    {editingChapter ? 'Edit Chapter' : 'Create New Chapter'}
                </h3>
                <form onSubmit={onSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-300 mb-2">
                            Chapter Title
                        </label>
                        <input
                            type="text"
                            value={chapterTitle}
                            onChange={(e) => setChapterTitle(e.target.value)}
                            placeholder="e.g., Chapter 1: Origins..."
                            className="w-full px-3 py-2 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500"
                            autoFocus
                        />
                    </div>
                    <div className="flex justify-end gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-300 hover:text-white transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={!chapterTitle.trim() || isSaving}
                            className="px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-purple-800 disabled:cursor-not-allowed text-white rounded-lg transition-colors"
                        >
                            {isSaving ? 'Saving...' : editingChapter ? 'Save Changes' : 'Create Chapter'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
